<template>
    <b-modal
        id="create-projects"
        v-model="modalShow"
        modal-class="apprentice-default-modal"
        :title="$t('group.set_up_papers')"
        ok-variant="primary"
        :ok-title="$t('common.create')"
        :cancel-title="$t('common.cancel')"
        @ok="onOk"
        cancel-variant="outline-primary"
        size="lg">
        <div class="row">
            <div class="col-6">
                <div class="text-muted">
                    {{ $t('group.papers_to_create') }}
                </div>
                <design-2021-apprentice-data-table
                    :fields="fields"
                    :items="addedStudents">
                </design-2021-apprentice-data-table>
            </div>
            <div class="col-6">
                <div class="text-muted">
                    {{ $t('group.papers_to_be_moved') }}
                </div>
                <design-2021-apprentice-data-table
                    :fields="fields"
                    :items="updatedStudents">
                </design-2021-apprentice-data-table>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-create-projects-modal-component',
    props: ['addedStudentsIn', 'updatedStudentsIn'],
    data() {
        return {
            modalShow: false,
            addedStudents: this.addedStudentsIn,
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
            ],
            updatedStudents: this.updatedStudentsIn,
        };
    },
    methods: {
        show(data) {
            this.modalShow = true;
            this.updatedStudents = data.updated;
            this.addedStudents = data.added;
        },
        onOk() {
            if (this.updatedStudents || this.addedStudents) {
                this.$emit('createProjects');
            }
        },
    },
};
</script>

<style scoped></style>
